export const CPartialTextMastheadFragments = {
  field: `
    fragment partialTextMasthead on partialTextMasthead_MatrixField {
      ... on partialTextMasthead_block_Entry {
        id
        typeHandle
        idName
        heading
        subheading
        button {
          text
          url
        }
        imageDesktop {
          title
          url
          hasFocalPoint
          focalPoint
        }
        imageMobile {
          title
          url
          hasFocalPoint
          focalPoint
        }
      }
    }
  `,
}
